module.exports = __webpack_public_path__ + "static/media/slide4.3e340806.jpg";